let setting = {};

export function setSetting(_setting) {
  setting = _setting;
}

export function getSetting() {
  return setting;
}
